export function initAsyncLoader() {
  $(document).off("click.asyncLoader", ".toggle-sequences-icon").on("click.asyncLoader", ".toggle-sequences-icon", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $icon = $(this);
    const $wrapper = $icon.closest("a");
    const url = $wrapper.data("async-url");
    const $content = $wrapper.find(".async-content");

    if ($content.html().trim() !== "") {
      toggleContent($content, $icon);
      return;
    }

    $icon.addClass("fa-spin");

    $.get(url, function (data) {
      $content.html(data);
      $icon.removeClass("fa-spin");
      $icon.removeClass("fa-caret-down").addClass("fa-caret-up");
      $content.show();
    }).fail(function () {
      console.error("Error loading content");
      $icon.removeClass("fa-spin");
    });
  });
}

function toggleContent($content, $icon) {
  if ($content.is(":visible")) {
    $content.hide();
    $icon.removeClass("fa-caret-up").addClass("fa-caret-down");
  } else {
    $content.show();
    $icon.removeClass("fa-caret-down").addClass("fa-caret-up");
  }
}
